module.exports = __webpack_public_path__ + "img/groupModeOn.88f250d5.svg";